// extracted by mini-css-extract-plugin
export default {"rentalYieldContainer":"YieldPage_rentalYieldContainer__ka-jG","tableContainer":"YieldPage_tableContainer__l7lIS","span":"YieldPage_span__Uxx3J"};